"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniversalClient = exports.Client = exports.OrderBy = exports.Op = exports.ZenqlQuery = exports.Query = void 0;
const tslib_1 = require("tslib");
var contensis_core_api_1 = require("contensis-core-api");
Object.defineProperty(exports, "Query", { enumerable: true, get: function () { return contensis_core_api_1.ManagementQuery; } });
Object.defineProperty(exports, "ZenqlQuery", { enumerable: true, get: function () { return contensis_core_api_1.ManagementZenqlQuery; } });
Object.defineProperty(exports, "Op", { enumerable: true, get: function () { return contensis_core_api_1.Op; } });
Object.defineProperty(exports, "OrderBy", { enumerable: true, get: function () { return contensis_core_api_1.OrderBy; } });
var client_1 = require("./client/client");
Object.defineProperty(exports, "Client", { enumerable: true, get: function () { return client_1.Client; } });
var universal_client_1 = require("./client/universal_client");
Object.defineProperty(exports, "UniversalClient", { enumerable: true, get: function () { return universal_client_1.UniversalClient; } });
tslib_1.__exportStar(require("./models"), exports);
